'use client';

import { useAppSelector } from 'src/hooks/redux-hooks';
import MaintenanceModePage from './MaintenanceModePage';
import useMaintenanceModePoll from './useMaintenanceModePoll';

/**
 * App-wide gate for backend maintenance mode.
 *
 * Mounted inside `src/app/providers.tsx` — the one client boundary every route
 * group renders (coordinator, vendor portal, auth, public), in both the
 * provider-islands-on and -off modes — so a `php artisan down` detected
 * anywhere covers the whole app, including the login page.
 *
 * It renders the window as a sibling overlay rather than replacing `children`:
 * unmounting the tree underneath would tear down in-flight work and, when
 * maintenance clears, we hard-navigate anyway.
 */
const MaintenanceGate = () => {
  const isActive = useAppSelector((state) => state.maintenance.isActive);
  const { isChecking, checkNow } = useMaintenanceModePoll(isActive);

  if (!isActive) return null;

  return <MaintenanceModePage isChecking={isChecking} onCheckNow={checkNow} />;
};

export default MaintenanceGate;
